// Generated on 2026-07-14T20:30:31.713Z
// This file contains preloaded vehicles models data from the API
// Do not edit manually - use 'npm run generate:vehicles-models-data' to regenerate

export const preloadedVehiclesModels: any = [
  {
    "marca": "HONDA",
    "modelo": "CR-V",
    "busquedas": "131777"
  },
  {
    "marca": "FORD",
    "modelo": "ESCAPE",
    "busquedas": "130096"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA",
    "busquedas": "116986"
  },
  {
    "marca": "HONDA",
    "modelo": "CIVIC",
    "busquedas": "96973"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA",
    "busquedas": "85270"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TACOMA",
    "busquedas": "38581"
  },
  {
    "marca": "KIA",
    "modelo": "SORENTO",
    "busquedas": "38079"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER",
    "busquedas": "31239"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER",
    "busquedas": "30324"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L200",
    "busquedas": "25521"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAV4",
    "busquedas": "25239"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HILUX",
    "busquedas": "24475"
  },
  {
    "marca": "FORD",
    "modelo": "RANGER",
    "busquedas": "22229"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER NP300 D23",
    "busquedas": "17746"
  },
  {
    "marca": "JEEP",
    "modelo": "PATRIOT",
    "busquedas": "17134"
  },
  {
    "marca": "ISUZU",
    "modelo": "D-MAX",
    "busquedas": "16181"
  },
  {
    "marca": "NISSAN",
    "modelo": "SENTRA",
    "busquedas": "14871"
  },
  {
    "marca": "TOYOTA",
    "modelo": "4RUNNER",
    "busquedas": "14560"
  },
  {
    "marca": "FORD",
    "modelo": "FOCUS",
    "busquedas": "14475"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE",
    "busquedas": "13641"
  },
  {
    "marca": "PONTIAC",
    "modelo": "VIBE",
    "busquedas": "12453"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "LANCER",
    "busquedas": "11749"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PICKUP",
    "busquedas": "11607"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER D22",
    "busquedas": "10978"
  },
  {
    "marca": "HONDA",
    "modelo": "FIT",
    "busquedas": "10787"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50",
    "busquedas": "10401"
  },
  {
    "marca": "KIA",
    "modelo": "SPORTAGE",
    "busquedas": "10181"
  },
  {
    "marca": "FORD",
    "modelo": "F-150",
    "busquedas": "9694"
  },
  {
    "marca": "HONDA",
    "modelo": "PILOT",
    "busquedas": "9510"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ACCENT",
    "busquedas": "9237"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TUCSON",
    "busquedas": "9201"
  },
  {
    "marca": "HONDA",
    "modelo": "ACCORD",
    "busquedas": "8844"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COLORADO",
    "busquedas": "8599"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE",
    "busquedas": "8400"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PRADO",
    "busquedas": "6803"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER",
    "busquedas": "6606"
  },
  {
    "marca": "MAZDA",
    "modelo": "3",
    "busquedas": "6462"
  },
  {
    "marca": "JEEP",
    "modelo": "WRANGLER",
    "busquedas": "6434"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MATRIX",
    "busquedas": "6228"
  },
  {
    "marca": "KIA",
    "modelo": "RIO",
    "busquedas": "6016"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK",
    "busquedas": "5937"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER",
    "busquedas": "5093"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIACE",
    "busquedas": "5003"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS",
    "busquedas": "4945"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO SPORT",
    "busquedas": "4777"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CAMRY",
    "busquedas": "4336"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "AMAROK",
    "busquedas": "4211"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALTIMA",
    "busquedas": "3986"
  },
  {
    "marca": "HONDA",
    "modelo": "ODYSSEY",
    "busquedas": "3896"
  },
  {
    "marca": "MAZDA",
    "modelo": "TRIBUTE",
    "busquedas": "3839"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA",
    "busquedas": "3808"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE SPORT",
    "busquedas": "3715"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE",
    "busquedas": "3702"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE",
    "busquedas": "3585"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA",
    "busquedas": "3565"
  },
  {
    "marca": "JEEP",
    "modelo": "COMPASS",
    "busquedas": "3533"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TERCEL",
    "busquedas": "3504"
  },
  {
    "marca": "JEEP",
    "modelo": "CHEROKEE",
    "busquedas": "3351"
  },
  {
    "marca": "NISSAN",
    "modelo": "NAVARA D40",
    "busquedas": "3331"
  },
  {
    "marca": "JEEP",
    "modelo": "GRAND CHEROKEE",
    "busquedas": "3130"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-100",
    "busquedas": "3097"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER SPORT",
    "busquedas": "3035"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TUNDRA",
    "busquedas": "2781"
  },
  {
    "marca": "HONDA",
    "modelo": "HR-V",
    "busquedas": "2724"
  },
  {
    "marca": "BMW",
    "modelo": "X3",
    "busquedas": "2681"
  },
  {
    "marca": "FORD",
    "modelo": "EDGE",
    "busquedas": "2499"
  },
  {
    "marca": "KIA",
    "modelo": "PICANTO",
    "busquedas": "2458"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO",
    "busquedas": "2398"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE",
    "busquedas": "2384"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAX",
    "busquedas": "2347"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SIENNA",
    "busquedas": "2347"
  },
  {
    "marca": "KIA",
    "modelo": "SOUL",
    "busquedas": "2308"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TAHOE",
    "busquedas": "2284"
  },
  {
    "marca": "NISSAN",
    "modelo": "XTERRA",
    "busquedas": "2225"
  },
  {
    "marca": "MAZDA",
    "modelo": "6",
    "busquedas": "2215"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO",
    "busquedas": "2153"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIGHLANDER",
    "busquedas": "2149"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2900",
    "busquedas": "2130"
  },
  {
    "marca": "HONDA",
    "modelo": "ELEMENT",
    "busquedas": "2032"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO",
    "busquedas": "2003"
  },
  {
    "marca": "NISSAN",
    "modelo": "D21",
    "busquedas": "1968"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "NATIVA",
    "busquedas": "1924"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND STAREX",
    "busquedas": "1912"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "S10",
    "busquedas": "1884"
  },
  {
    "marca": "KIA",
    "modelo": "SEPHIA",
    "busquedas": "1857"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "GALANT",
    "busquedas": "1810"
  },
  {
    "marca": "FORD",
    "modelo": "EXPEDITION",
    "busquedas": "1795"
  },
  {
    "marca": "BMW",
    "modelo": "X5",
    "busquedas": "1787"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2500",
    "busquedas": "1761"
  },
  {
    "marca": "NISSAN",
    "modelo": "PICKUP",
    "busquedas": "1734"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI",
    "busquedas": "1724"
  },
  {
    "marca": "DODGE",
    "modelo": "NEON",
    "busquedas": "1693"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER",
    "busquedas": "1636"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500",
    "busquedas": "1629"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN",
    "busquedas": "1596"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP KB",
    "busquedas": "1518"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER",
    "busquedas": "1511"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SONATA",
    "busquedas": "1479"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATROL",
    "busquedas": "1396"
  },
  {
    "marca": "FORD",
    "modelo": "MUSTANG",
    "busquedas": "1380"
  },
  {
    "marca": "NISSAN",
    "modelo": "X-TRAIL",
    "busquedas": "1353"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EQUINOX",
    "busquedas": "1341"
  },
  {
    "marca": "BMW",
    "modelo": "328I",
    "busquedas": "1340"
  },
  {
    "marca": "SUZUKI",
    "modelo": "GRAND VITARA",
    "busquedas": "1284"
  },
  {
    "marca": "NISSAN",
    "modelo": "MURANO",
    "busquedas": "1178"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-7",
    "busquedas": "1051"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRACKER",
    "busquedas": "1039"
  },
  {
    "marca": "FORD",
    "modelo": "F-250 SUPER DUTY",
    "busquedas": "1035"
  },
  {
    "marca": "RAM",
    "modelo": "1500",
    "busquedas": "1032"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "JETTA",
    "busquedas": "1018"
  },
  {
    "marca": "HONDA",
    "modelo": "RIDGELINE",
    "busquedas": "1012"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EON",
    "busquedas": "1010"
  },
  {
    "marca": "JEEP",
    "modelo": "LIBERTY",
    "busquedas": "994"
  },
  {
    "marca": "MERCURY",
    "modelo": "MARINER",
    "busquedas": "957"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2200",
    "busquedas": "903"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500",
    "busquedas": "875"
  },
  {
    "marca": "MAZDA",
    "modelo": "323",
    "busquedas": "868"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN NV350",
    "busquedas": "868"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE",
    "busquedas": "846"
  },
  {
    "marca": "FORD",
    "modelo": "ESCORT",
    "busquedas": "833"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONIC",
    "busquedas": "833"
  },
  {
    "marca": "NISSAN",
    "modelo": "KICKS",
    "busquedas": "828"
  },
  {
    "marca": "MAZDA",
    "modelo": "626",
    "busquedas": "823"
  },
  {
    "marca": "DODGE",
    "modelo": "DAKOTA",
    "busquedas": "813"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I10",
    "busquedas": "812"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT TRAC",
    "busquedas": "786"
  },
  {
    "marca": "TOYOTA",
    "modelo": "ECHO",
    "busquedas": "779"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV200",
    "busquedas": "767"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500",
    "busquedas": "766"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA",
    "busquedas": "748"
  },
  {
    "marca": "GMC",
    "modelo": "CANYON",
    "busquedas": "720"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-5",
    "busquedas": "709"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50 PRO",
    "busquedas": "700"
  },
  {
    "marca": "NISSAN",
    "modelo": "TIIDA",
    "busquedas": "692"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L300",
    "busquedas": "686"
  },
  {
    "marca": "DODGE",
    "modelo": "CARAVAN",
    "busquedas": "680"
  },
  {
    "marca": "JEEP",
    "modelo": "RENEGADE",
    "busquedas": "662"
  },
  {
    "marca": "SUZUKI",
    "modelo": "ESTEEM",
    "busquedas": "643"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-1",
    "busquedas": "623"
  },
  {
    "marca": "MAZDA",
    "modelo": "2",
    "busquedas": "609"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VITARA",
    "busquedas": "607"
  },
  {
    "marca": "SCION",
    "modelo": "XA",
    "busquedas": "607"
  },
  {
    "marca": "SUBARU",
    "modelo": "FORESTER",
    "busquedas": "605"
  },
  {
    "marca": "NISSAN",
    "modelo": "JUKE",
    "busquedas": "598"
  },
  {
    "marca": "SCION",
    "modelo": "XB",
    "busquedas": "592"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN",
    "busquedas": "568"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CELICA",
    "busquedas": "543"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP",
    "busquedas": "534"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT CONNECT",
    "busquedas": "534"
  },
  {
    "marca": "BMW",
    "modelo": "325I",
    "busquedas": "527"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND I10",
    "busquedas": "508"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TIBURON",
    "busquedas": "507"
  },
  {
    "marca": "RAM",
    "modelo": "2500",
    "busquedas": "494"
  },
  {
    "marca": "KIA",
    "modelo": "OPTIMA",
    "busquedas": "492"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "PRIZM",
    "busquedas": "492"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TIGUAN",
    "busquedas": "492"
  },
  {
    "marca": "ACURA",
    "modelo": "RDX",
    "busquedas": "488"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2300",
    "busquedas": "484"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ENDEAVOR",
    "busquedas": "482"
  },
  {
    "marca": "SUZUKI",
    "modelo": "FORENZA",
    "busquedas": "472"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE",
    "busquedas": "465"
  },
  {
    "marca": "DODGE",
    "modelo": "GRAND CARAVAN",
    "busquedas": "465"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA",
    "busquedas": "447"
  },
  {
    "marca": "SUZUKI",
    "modelo": "AERIO",
    "busquedas": "445"
  },
  {
    "marca": "NISSAN",
    "modelo": "350Z",
    "busquedas": "444"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE",
    "busquedas": "439"
  },
  {
    "marca": "SCION",
    "modelo": "XD",
    "busquedas": "434"
  },
  {
    "marca": "SUBARU",
    "modelo": "IMPREZA",
    "busquedas": "432"
  },
  {
    "marca": "FORD",
    "modelo": "FUSION",
    "busquedas": "422"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SWIFT",
    "busquedas": "415"
  },
  {
    "marca": "BMW",
    "modelo": "Z4",
    "busquedas": "408"
  },
  {
    "marca": "SCION",
    "modelo": "TC",
    "busquedas": "404"
  },
  {
    "marca": "HUMMER",
    "modelo": "H3",
    "busquedas": "404"
  },
  {
    "marca": "ACURA",
    "modelo": "TSX",
    "busquedas": "403"
  },
  {
    "marca": "SUZUKI",
    "modelo": "APV",
    "busquedas": "389"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAMARO",
    "busquedas": "385"
  },
  {
    "marca": "FORD",
    "modelo": "F-350 SUPER DUTY",
    "busquedas": "384"
  },
  {
    "marca": "NISSAN",
    "modelo": "720",
    "busquedas": "384"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "CRETA",
    "busquedas": "375"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500",
    "busquedas": "370"
  },
  {
    "marca": "FORD",
    "modelo": "ECOSPORT",
    "busquedas": "366"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300",
    "busquedas": "361"
  },
  {
    "marca": "ACURA",
    "modelo": "MDX",
    "busquedas": "343"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SX4",
    "busquedas": "335"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SIDEKICK",
    "busquedas": "331"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FORTUNER",
    "busquedas": "330"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TERRACAN",
    "busquedas": "327"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VELOSTER",
    "busquedas": "323"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-9",
    "busquedas": "318"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN",
    "busquedas": "316"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAVALIER",
    "busquedas": "315"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "METRO",
    "busquedas": "309"
  },
  {
    "marca": "ISUZU",
    "modelo": "TROOPER",
    "busquedas": "308"
  },
  {
    "marca": "ACURA",
    "modelo": "RSX",
    "busquedas": "307"
  },
  {
    "marca": "SUBARU",
    "modelo": "OUTBACK",
    "busquedas": "305"
  },
  {
    "marca": "MAZDA",
    "modelo": "5",
    "busquedas": "301"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2000",
    "busquedas": "293"
  },
  {
    "marca": "SUBARU",
    "modelo": "LEGACY",
    "busquedas": "291"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SEQUOIA",
    "busquedas": "286"
  },
  {
    "marca": "BMW",
    "modelo": "X1",
    "busquedas": "285"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU",
    "busquedas": "282"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500",
    "busquedas": "280"
  },
  {
    "marca": "SATURN",
    "modelo": "VUE",
    "busquedas": "276"
  },
  {
    "marca": "NISSAN",
    "modelo": "MAXIMA",
    "busquedas": "275"
  },
  {
    "marca": "SUZUKI",
    "modelo": "JIMNY",
    "busquedas": "275"
  },
  {
    "marca": "ACURA",
    "modelo": "TL",
    "busquedas": "270"
  },
  {
    "marca": "DODGE",
    "modelo": "CALIBER",
    "busquedas": "268"
  },
  {
    "marca": "DODGE",
    "modelo": "JOURNEY",
    "busquedas": "257"
  },
  {
    "marca": "NISSAN",
    "modelo": "ARMADA",
    "busquedas": "251"
  },
  {
    "marca": "MAZDA",
    "modelo": "MPV",
    "busquedas": "247"
  },
  {
    "marca": "DODGE",
    "modelo": "DURANGO",
    "busquedas": "242"
  },
  {
    "marca": "TOYOTA",
    "modelo": "T100",
    "busquedas": "242"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N300",
    "busquedas": "237"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BLAZER",
    "busquedas": "234"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT",
    "busquedas": "229"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FJ CRUISER",
    "busquedas": "228"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAVERSE",
    "busquedas": "227"
  },
  {
    "marca": "GMC",
    "modelo": "ACADIA",
    "busquedas": "225"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE5",
    "busquedas": "219"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA SPORT",
    "busquedas": "214"
  },
  {
    "marca": "BMW",
    "modelo": "528I",
    "busquedas": "212"
  },
  {
    "marca": "DODGE",
    "modelo": "DART",
    "busquedas": "212"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALMERA",
    "busquedas": "211"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500 HD",
    "busquedas": "211"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-290",
    "busquedas": "202"
  },
  {
    "marca": "JEEP",
    "modelo": "GLADIATOR",
    "busquedas": "197"
  },
  {
    "marca": "ISUZU",
    "modelo": "MU-X",
    "busquedas": "196"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ASX",
    "busquedas": "194"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 1500",
    "busquedas": "193"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER COUNTRYMAN",
    "busquedas": "191"
  },
  {
    "marca": "VOLVO",
    "modelo": "S60",
    "busquedas": "191"
  },
  {
    "marca": "GEO",
    "modelo": "PRIZM",
    "busquedas": "187"
  },
  {
    "marca": "BMW",
    "modelo": "335I",
    "busquedas": "187"
  },
  {
    "marca": "PORSCHE",
    "modelo": "CAYENNE",
    "busquedas": "187"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PT CRUISER",
    "busquedas": "186"
  },
  {
    "marca": "VOLVO",
    "modelo": "S40",
    "busquedas": "186"
  },
  {
    "marca": "ACURA",
    "modelo": "INTEGRA",
    "busquedas": "185"
  },
  {
    "marca": "KIA",
    "modelo": "SEDONA",
    "busquedas": "183"
  },
  {
    "marca": "NISSAN",
    "modelo": "QUEST",
    "busquedas": "181"
  },
  {
    "marca": "MAZDA",
    "modelo": "B3000",
    "busquedas": "176"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SAMURAI",
    "busquedas": "175"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VERACRUZ",
    "busquedas": "173"
  },
  {
    "marca": "SUZUKI",
    "modelo": "XL-7",
    "busquedas": "172"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PICKUP",
    "busquedas": "170"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX470",
    "busquedas": "168"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC90",
    "busquedas": "167"
  },
  {
    "marca": "BMW",
    "modelo": "X6",
    "busquedas": "161"
  },
  {
    "marca": "AUDI",
    "modelo": "Q7",
    "busquedas": "161"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA GT",
    "busquedas": "159"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS",
    "busquedas": "157"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX300",
    "busquedas": "156"
  },
  {
    "marca": "ACURA",
    "modelo": "ILX",
    "busquedas": "156"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COBALT",
    "busquedas": "151"
  },
  {
    "marca": "DODGE",
    "modelo": "CHALLENGER",
    "busquedas": "151"
  },
  {
    "marca": "AUDI",
    "modelo": "A4",
    "busquedas": "150"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX470",
    "busquedas": "147"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "TOWN & COUNTRY",
    "busquedas": "146"
  },
  {
    "marca": "MAZDA",
    "modelo": "B4000",
    "busquedas": "144"
  },
  {
    "marca": "FORD",
    "modelo": "F-250",
    "busquedas": "139"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N400",
    "busquedas": "138"
  },
  {
    "marca": "ISUZU",
    "modelo": "HOMBRE",
    "busquedas": "135"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAILBLAZER",
    "busquedas": "134"
  },
  {
    "marca": "HONDA",
    "modelo": "PASSPORT",
    "busquedas": "133"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "VENTURE",
    "busquedas": "128"
  },
  {
    "marca": "GMC",
    "modelo": "SONOMA",
    "busquedas": "128"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "STAREX",
    "busquedas": "125"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BEETLE",
    "busquedas": "125"
  },
  {
    "marca": "BMW",
    "modelo": "328I XDRIVE",
    "busquedas": "122"
  },
  {
    "marca": "AUDI",
    "modelo": "Q5",
    "busquedas": "118"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE",
    "busquedas": "116"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VENZA",
    "busquedas": "114"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SPORT",
    "busquedas": "113"
  },
  {
    "marca": "BMW",
    "modelo": "128I",
    "busquedas": "110"
  },
  {
    "marca": "LINCOLN",
    "modelo": "NAVIGATOR",
    "busquedas": "110"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOLF",
    "busquedas": "108"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TOUAREG",
    "busquedas": "107"
  },
  {
    "marca": "DODGE",
    "modelo": "NITRO",
    "busquedas": "107"
  },
  {
    "marca": "GEO",
    "modelo": "METRO",
    "busquedas": "107"
  },
  {
    "marca": "RAM",
    "modelo": "3500",
    "busquedas": "106"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2600",
    "busquedas": "105"
  },
  {
    "marca": "SUZUKI",
    "modelo": "RENO",
    "busquedas": "104"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS",
    "busquedas": "103"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ATOS",
    "busquedas": "102"
  },
  {
    "marca": "BMW",
    "modelo": "325CI",
    "busquedas": "102"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C230",
    "busquedas": "100"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "MATRIX",
    "busquedas": "100"
  },
  {
    "marca": "FORD",
    "modelo": "WINDSTAR",
    "busquedas": "98"
  },
  {
    "marca": "BMW",
    "modelo": "330I",
    "busquedas": "97"
  },
  {
    "marca": "BMW",
    "modelo": "320I",
    "busquedas": "97"
  },
  {
    "marca": "SUZUKI",
    "modelo": "EQUATOR",
    "busquedas": "96"
  },
  {
    "marca": "FIAT",
    "modelo": "500",
    "busquedas": "95"
  },
  {
    "marca": "HONDA",
    "modelo": "CITY",
    "busquedas": "94"
  },
  {
    "marca": "BMW",
    "modelo": "330CI",
    "busquedas": "94"
  },
  {
    "marca": "GMC",
    "modelo": "TERRAIN",
    "busquedas": "94"
  },
  {
    "marca": "BMW",
    "modelo": "323I",
    "busquedas": "93"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIGHTY MAX",
    "busquedas": "91"
  },
  {
    "marca": "KIA",
    "modelo": "PREGIO",
    "busquedas": "90"
  },
  {
    "marca": "DODGE",
    "modelo": "AVENGER",
    "busquedas": "88"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA5",
    "busquedas": "88"
  },
  {
    "marca": "BMW",
    "modelo": "325XI",
    "busquedas": "87"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV350 URVAN",
    "busquedas": "86"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "RAIDER",
    "busquedas": "85"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVALON",
    "busquedas": "85"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE G4",
    "busquedas": "85"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "200",
    "busquedas": "84"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX460",
    "busquedas": "83"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX60",
    "busquedas": "83"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C300",
    "busquedas": "82"
  },
  {
    "marca": "BMW",
    "modelo": "525I",
    "busquedas": "82"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE 1500",
    "busquedas": "81"
  },
  {
    "marca": "BMW",
    "modelo": "535I",
    "busquedas": "80"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS250",
    "busquedas": "80"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CITY EXPRESS",
    "busquedas": "80"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C250",
    "busquedas": "79"
  },
  {
    "marca": "SUZUKI",
    "modelo": "CELERIO",
    "busquedas": "79"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX4",
    "busquedas": "79"
  },
  {
    "marca": "KIA",
    "modelo": "CERATO",
    "busquedas": "79"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 SUPER DUTY",
    "busquedas": "78"
  },
  {
    "marca": "SUBARU",
    "modelo": "BAJA",
    "busquedas": "76"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "OPTRA",
    "busquedas": "76"
  },
  {
    "marca": "DODGE",
    "modelo": "CHARGER",
    "busquedas": "75"
  },
  {
    "marca": "FORD",
    "modelo": "EXCURSION",
    "busquedas": "74"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX330",
    "busquedas": "73"
  },
  {
    "marca": "TOYOTA",
    "modelo": "URBAN CRUISER",
    "busquedas": "73"
  },
  {
    "marca": "HONDA",
    "modelo": "CROSSTOUR",
    "busquedas": "73"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON",
    "busquedas": "72"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA NOTE",
    "busquedas": "72"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO SPORT",
    "busquedas": "72"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML350",
    "busquedas": "70"
  },
  {
    "marca": "HUMMER",
    "modelo": "H2",
    "busquedas": "69"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BEAT",
    "busquedas": "69"
  },
  {
    "marca": "KIA",
    "modelo": "SELTOS",
    "busquedas": "68"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVENSIS",
    "busquedas": "68"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GTI",
    "busquedas": "66"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY",
    "busquedas": "66"
  },
  {
    "marca": "ISUZU",
    "modelo": "AMIGO",
    "busquedas": "66"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE LIMITED",
    "busquedas": "65"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E320",
    "busquedas": "65"
  },
  {
    "marca": "KIA",
    "modelo": "RONDO",
    "busquedas": "65"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "SEBRING",
    "busquedas": "65"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "TERIOS",
    "busquedas": "64"
  },
  {
    "marca": "INFINITI",
    "modelo": "FX35",
    "busquedas": "64"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EXCEL",
    "busquedas": "64"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-280",
    "busquedas": "60"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CRESSIDA",
    "busquedas": "59"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SOLSTICE",
    "busquedas": "58"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRACE",
    "busquedas": "58"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX80",
    "busquedas": "57"
  },
  {
    "marca": "BMW",
    "modelo": "318I",
    "busquedas": "56"
  },
  {
    "marca": "AUDI",
    "modelo": "TT",
    "busquedas": "55"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VENUE",
    "busquedas": "55"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "HHR",
    "busquedas": "55"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER",
    "busquedas": "54"
  },
  {
    "marca": "JAGUAR",
    "modelo": "X-TYPE",
    "busquedas": "53"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS COUPE",
    "busquedas": "53"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500 HD",
    "busquedas": "52"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT",
    "busquedas": "52"
  },
  {
    "marca": "GEO",
    "modelo": "TRACKER",
    "busquedas": "52"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY",
    "busquedas": "51"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "300",
    "busquedas": "51"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA COUPE",
    "busquedas": "51"
  },
  {
    "marca": "NISSAN",
    "modelo": "CUBE",
    "busquedas": "51"
  },
  {
    "marca": "BMW",
    "modelo": "323CI",
    "busquedas": "51"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PACIFICA",
    "busquedas": "50"
  },
  {
    "marca": "KIA",
    "modelo": "RIO5",
    "busquedas": "50"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKX",
    "busquedas": "49"
  },
  {
    "marca": "CADILLAC",
    "modelo": "SRX",
    "busquedas": "48"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-3",
    "busquedas": "48"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "GROOVE",
    "busquedas": "48"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GETZ",
    "busquedas": "47"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TAOS",
    "busquedas": "46"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SUNFIRE",
    "busquedas": "46"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER SPORT",
    "busquedas": "46"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE CROSS",
    "busquedas": "46"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL450",
    "busquedas": "45"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "IMPALA",
    "busquedas": "45"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO SPORT",
    "busquedas": "45"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS IA",
    "busquedas": "44"
  },
  {
    "marca": "JEEP",
    "modelo": "COMMANDER",
    "busquedas": "44"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500",
    "busquedas": "44"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G6",
    "busquedas": "43"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS300",
    "busquedas": "43"
  },
  {
    "marca": "PONTIAC",
    "modelo": "TORRENT",
    "busquedas": "43"
  },
  {
    "marca": "BMW",
    "modelo": "Z3",
    "busquedas": "42"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "R350",
    "busquedas": "42"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC70",
    "busquedas": "42"
  },
  {
    "marca": "BMW",
    "modelo": "530I",
    "busquedas": "41"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ENTOURAGE",
    "busquedas": "41"
  },
  {
    "marca": "MAZDA",
    "modelo": "MIATA",
    "busquedas": "40"
  },
  {
    "marca": "BMW",
    "modelo": "X4",
    "busquedas": "40"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC60",
    "busquedas": "40"
  },
  {
    "marca": "LINCOLN",
    "modelo": "AVIATOR",
    "busquedas": "39"
  },
  {
    "marca": "VOLVO",
    "modelo": "S80",
    "busquedas": "39"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SUPRA",
    "busquedas": "39"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300 FRONTIER",
    "busquedas": "39"
  },
  {
    "marca": "MERCURY",
    "modelo": "TRACER",
    "busquedas": "39"
  },
  {
    "marca": "SCION",
    "modelo": "IQ",
    "busquedas": "38"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 3500",
    "busquedas": "38"
  },
  {
    "marca": "BMW",
    "modelo": "330XI",
    "busquedas": "38"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "SIRION",
    "busquedas": "38"
  },
  {
    "marca": "TOYOTA",
    "modelo": "STARLET",
    "busquedas": "38"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-150",
    "busquedas": "37"
  },
  {
    "marca": "NISSAN",
    "modelo": "240SX",
    "busquedas": "37"
  },
  {
    "marca": "CADILLAC",
    "modelo": "CTS",
    "busquedas": "37"
  },
  {
    "marca": "FORD",
    "modelo": "E-150",
    "busquedas": "37"
  },
  {
    "marca": "HONDA",
    "modelo": "INSIGHT",
    "busquedas": "36"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML320",
    "busquedas": "36"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX350",
    "busquedas": "36"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-MARK",
    "busquedas": "35"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO",
    "busquedas": "35"
  },
  {
    "marca": "FORD",
    "modelo": "FLEX",
    "busquedas": "34"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER II",
    "busquedas": "34"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 1500",
    "busquedas": "34"
  },
  {
    "marca": "AUDI",
    "modelo": "S4",
    "busquedas": "33"
  },
  {
    "marca": "SATURN",
    "modelo": "SL1",
    "busquedas": "33"
  },
  {
    "marca": "SATURN",
    "modelo": "SL2",
    "busquedas": "33"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-350",
    "busquedas": "32"
  },
  {
    "marca": "INFINITI",
    "modelo": "G35",
    "busquedas": "32"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "NEON",
    "busquedas": "32"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I20",
    "busquedas": "32"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCORE",
    "busquedas": "31"
  },
  {
    "marca": "DODGE",
    "modelo": "STRATUS",
    "busquedas": "31"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 2500",
    "busquedas": "31"
  },
  {
    "marca": "SATURN",
    "modelo": "ION",
    "busquedas": "31"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PREVIA",
    "busquedas": "31"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COASTER",
    "busquedas": "30"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES330",
    "busquedas": "30"
  },
  {
    "marca": "HONDA",
    "modelo": "PRELUDE",
    "busquedas": "30"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORVETTE",
    "busquedas": "30"
  },
  {
    "marca": "BMW",
    "modelo": "328XI",
    "busquedas": "30"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CC",
    "busquedas": "29"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LANOS",
    "busquedas": "29"
  },
  {
    "marca": "SUZUKI",
    "modelo": "S-PRESSO",
    "busquedas": "29"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLK350",
    "busquedas": "29"
  },
  {
    "marca": "KIA",
    "modelo": "SOLUTO",
    "busquedas": "28"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "PALISADE",
    "busquedas": "28"
  },
  {
    "marca": "HONDA",
    "modelo": "CR-Z",
    "busquedas": "28"
  },
  {
    "marca": "BMW",
    "modelo": "135I",
    "busquedas": "28"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMV",
    "busquedas": "27"
  },
  {
    "marca": "KIA",
    "modelo": "SONET",
    "busquedas": "27"
  },
  {
    "marca": "SATURN",
    "modelo": "SL",
    "busquedas": "27"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "FREELANDER",
    "busquedas": "27"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES300",
    "busquedas": "27"
  },
  {
    "marca": "FORD",
    "modelo": "CONTOUR",
    "busquedas": "26"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SOLARA",
    "busquedas": "26"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "ATLAS",
    "busquedas": "26"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX56",
    "busquedas": "25"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "VOYAGER",
    "busquedas": "25"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G5",
    "busquedas": "25"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RUSH",
    "busquedas": "25"
  },
  {
    "marca": "KIA",
    "modelo": "BORREGO",
    "busquedas": "25"
  },
  {
    "marca": "NISSAN",
    "modelo": "370Z",
    "busquedas": "25"
  },
  {
    "marca": "VOLVO",
    "modelo": "V70",
    "busquedas": "25"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500 HD",
    "busquedas": "25"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK250",
    "busquedas": "24"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN XD",
    "busquedas": "24"
  },
  {
    "marca": "ACURA",
    "modelo": "TLX",
    "busquedas": "24"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "POLO",
    "busquedas": "24"
  },
  {
    "marca": "MERCURY",
    "modelo": "MOUNTAINEER",
    "busquedas": "23"
  },
  {
    "marca": "SCION",
    "modelo": "IM",
    "busquedas": "23"
  },
  {
    "marca": "KIA",
    "modelo": "CARENS",
    "busquedas": "23"
  },
  {
    "marca": "GMC",
    "modelo": "SAFARI",
    "busquedas": "22"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO IO",
    "busquedas": "22"
  },
  {
    "marca": "FORD",
    "modelo": "E-250",
    "busquedas": "22"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI+2",
    "busquedas": "22"
  },
  {
    "marca": "BMW",
    "modelo": "318IS",
    "busquedas": "22"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C320",
    "busquedas": "22"
  },
  {
    "marca": "INFINITI",
    "modelo": "JX35",
    "busquedas": "21"
  },
  {
    "marca": "KIA",
    "modelo": "TELLURIDE",
    "busquedas": "21"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VAN",
    "busquedas": "21"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "3000GT",
    "busquedas": "21"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 LTD",
    "busquedas": "21"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SELECT",
    "busquedas": "21"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 2500",
    "busquedas": "20"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 2500",
    "busquedas": "20"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND PRIX",
    "busquedas": "20"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTYLE",
    "busquedas": "19"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C240",
    "busquedas": "19"
  },
  {
    "marca": "PORSCHE",
    "modelo": "BOXSTER",
    "busquedas": "19"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO II",
    "busquedas": "19"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO",
    "busquedas": "19"
  },
  {
    "marca": "RENAULT",
    "modelo": "KOLEOS",
    "busquedas": "19"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA IM",
    "busquedas": "18"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-30",
    "busquedas": "18"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500",
    "busquedas": "18"
  },
  {
    "marca": "RAM",
    "modelo": "1500 CLASSIC",
    "busquedas": "18"
  },
  {
    "marca": "NISSAN",
    "modelo": "MARCH",
    "busquedas": "18"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "ASTRO",
    "busquedas": "18"
  },
  {
    "marca": "FORD",
    "modelo": "F-350",
    "busquedas": "17"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "VOYAGER",
    "busquedas": "17"
  },
  {
    "marca": "RAM",
    "modelo": "700",
    "busquedas": "17"
  },
  {
    "marca": "SCION",
    "modelo": "FR-S",
    "busquedas": "17"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX570",
    "busquedas": "17"
  },
  {
    "marca": "VOLVO",
    "modelo": "S70",
    "busquedas": "17"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCLAVE",
    "busquedas": "17"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C1500",
    "busquedas": "17"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTAR",
    "busquedas": "17"
  },
  {
    "marca": "SUBARU",
    "modelo": "XV CROSSTREK",
    "busquedas": "16"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS400",
    "busquedas": "16"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR2",
    "busquedas": "16"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5 MIATA",
    "busquedas": "16"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS300",
    "busquedas": "16"
  },
  {
    "marca": "FORD",
    "modelo": "FIGO",
    "busquedas": "16"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER EVOQUE",
    "busquedas": "16"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E350",
    "busquedas": "16"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAIZE",
    "busquedas": "15"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CORONA",
    "busquedas": "15"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL320",
    "busquedas": "15"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C280",
    "busquedas": "15"
  },
  {
    "marca": "SUZUKI",
    "modelo": "IGNIS",
    "busquedas": "15"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE ESV",
    "busquedas": "15"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK350",
    "busquedas": "14"
  },
  {
    "marca": "HONDA",
    "modelo": "S2000",
    "busquedas": "14"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO5",
    "busquedas": "14"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK300",
    "busquedas": "13"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER PACEMAN",
    "busquedas": "13"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "SAVEIRO",
    "busquedas": "13"
  },
  {
    "marca": "DODGE",
    "modelo": "D350",
    "busquedas": "13"
  },
  {
    "marca": "MAHINDRA",
    "modelo": "SCORPIO",
    "busquedas": "13"
  },
  {
    "marca": "SUBARU",
    "modelo": "CROSSTREK",
    "busquedas": "13"
  },
  {
    "marca": "KIA",
    "modelo": "CARNIVAL",
    "busquedas": "13"
  },
  {
    "marca": "GMC",
    "modelo": "JIMMY",
    "busquedas": "13"
  },
  {
    "marca": "BMW",
    "modelo": "335I XDRIVE",
    "busquedas": "13"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CROSSFOX",
    "busquedas": "13"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "300D",
    "busquedas": "13"
  },
  {
    "marca": "VOLVO",
    "modelo": "C70",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-250",
    "busquedas": "12"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "S10 BLAZER",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "640I",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "FESTIVA",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE CLUB WAGON",
    "busquedas": "12"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS200",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "740I",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "540I",
    "busquedas": "12"
  },
  {
    "marca": "KIA",
    "modelo": "PRIDE",
    "busquedas": "12"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRAT",
    "busquedas": "12"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PASEO",
    "busquedas": "12"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER ARMADA",
    "busquedas": "12"
  },
  {
    "marca": "JMC",
    "modelo": "VIGUS",
    "busquedas": "11"
  },
  {
    "marca": "INFINITI",
    "modelo": "G37",
    "busquedas": "11"
  },
  {
    "marca": "ISUZU",
    "modelo": "AXIOM",
    "busquedas": "11"
  },
  {
    "marca": "CADILLAC",
    "modelo": "XT5",
    "busquedas": "11"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE",
    "busquedas": "11"
  },
  {
    "marca": "NISSAN",
    "modelo": "200SX",
    "busquedas": "11"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE KOUP",
    "busquedas": "11"
  },
  {
    "marca": "NISSAN",
    "modelo": "STANZA",
    "busquedas": "11"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "BREEZE",
    "busquedas": "11"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C1500 SUBURBAN",
    "busquedas": "11"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX450",
    "busquedas": "11"
  },
  {
    "marca": "PORSCHE",
    "modelo": "MACAN",
    "busquedas": "11"
  },
  {
    "marca": "BUICK",
    "modelo": "RENDEZVOUS",
    "busquedas": "11"
  },
  {
    "marca": "AUDI",
    "modelo": "A3",
    "busquedas": "11"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C350",
    "busquedas": "11"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "ROUTAN",
    "busquedas": "11"
  },
  {
    "marca": "MAZDA",
    "modelo": "RX-8",
    "busquedas": "10"
  },
  {
    "marca": "FORD",
    "modelo": "AEROSTAR",
    "busquedas": "10"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRZ",
    "busquedas": "10"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "GRAND VOYAGER",
    "busquedas": "10"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 LD",
    "busquedas": "10"
  },
  {
    "marca": "JMC",
    "modelo": "PICK UP",
    "busquedas": "10"
  },
  {
    "marca": "SATURN",
    "modelo": "OUTLOOK",
    "busquedas": "10"
  },
  {
    "marca": "HONDA",
    "modelo": "CIVIC DEL SOL",
    "busquedas": "10"
  },
  {
    "marca": "PORSCHE",
    "modelo": "PANAMERA",
    "busquedas": "10"
  },
  {
    "marca": "DODGE",
    "modelo": "RAIDER",
    "busquedas": "10"
  },
  {
    "marca": "HONDA",
    "modelo": "CRX",
    "busquedas": "10"
  },
  {
    "marca": "SUZUKI",
    "modelo": "ERTIGA",
    "busquedas": "10"
  },
  {
    "marca": "RENAULT",
    "modelo": "CLIO",
    "busquedas": "10"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 1500",
    "busquedas": "10"
  },
  {
    "marca": "AUDI",
    "modelo": "A6",
    "busquedas": "10"
  },
  {
    "marca": "INFINITI",
    "modelo": "G20",
    "busquedas": "10"
  },
  {
    "marca": "MAZDA",
    "modelo": "MILLENIA",
    "busquedas": "10"
  },
  {
    "marca": "JMC",
    "modelo": "GRAND AVENUE",
    "busquedas": "9"
  },
  {
    "marca": "ZNA",
    "modelo": "RICH 6",
    "busquedas": "9"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE",
    "busquedas": "9"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500",
    "busquedas": "9"
  },
  {
    "marca": "BMW",
    "modelo": "528I XDRIVE",
    "busquedas": "9"
  },
  {
    "marca": "AUDI",
    "modelo": "A4 QUATTRO",
    "busquedas": "9"
  },
  {
    "marca": "BMW",
    "modelo": "325ES",
    "busquedas": "9"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK500",
    "busquedas": "9"
  },
  {
    "marca": "SCION",
    "modelo": "IA",
    "busquedas": "9"
  },
  {
    "marca": "FOTON",
    "modelo": "TUNLAND",
    "busquedas": "9"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "K1500",
    "busquedas": "9"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA CROSS",
    "busquedas": "9"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S350",
    "busquedas": "8"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND AM",
    "busquedas": "8"
  },
  {
    "marca": "KIA",
    "modelo": "MOHAVE",
    "busquedas": "8"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-50",
    "busquedas": "8"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA",
    "busquedas": "8"
  },
  {
    "marca": "FORD",
    "modelo": "F-250 HD",
    "busquedas": "8"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS V",
    "busquedas": "8"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMP",
    "busquedas": "8"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "KONA",
    "busquedas": "8"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKS",
    "busquedas": "8"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLA250",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "328D XDRIVE",
    "busquedas": "8"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK230",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "325E",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "318TI",
    "busquedas": "8"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "RABBIT",
    "busquedas": "8"
  },
  {
    "marca": "BUICK",
    "modelo": "LACROSSE",
    "busquedas": "8"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-370",
    "busquedas": "7"
  },
  {
    "marca": "MERCURY",
    "modelo": "COUGAR",
    "busquedas": "7"
  },
  {
    "marca": "JIM",
    "modelo": "REMAX",
    "busquedas": "7"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR3",
    "busquedas": "7"
  },
  {
    "marca": "FORD",
    "modelo": "FIVE HUNDRED",
    "busquedas": "7"
  },
  {
    "marca": "SATURN",
    "modelo": "SW1",
    "busquedas": "7"
  },
  {
    "marca": "FORD",
    "modelo": "MAVERICK",
    "busquedas": "7"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2 SPYDER",
    "busquedas": "7"
  },
  {
    "marca": "KIA",
    "modelo": "AMANTI",
    "busquedas": "7"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER PHEV",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "650I",
    "busquedas": "7"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2",
    "busquedas": "7"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LEGANZA",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "428I",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "335XI",
    "busquedas": "7"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LITE ACE",
    "busquedas": "7"
  },
  {
    "marca": "GMC",
    "modelo": "S15",
    "busquedas": "7"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS350",
    "busquedas": "7"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX400H",
    "busquedas": "7"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "STARIA",
    "busquedas": "7"
  },
  {
    "marca": "LEXUS",
    "modelo": "NX300",
    "busquedas": "7"
  },
  {
    "marca": "AUDI",
    "modelo": "A5 QUATTRO",
    "busquedas": "7"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "AZERA",
    "busquedas": "7"
  },
  {
    "marca": "DAEWOO",
    "modelo": "NUBIRA",
    "busquedas": "7"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C3500",
    "busquedas": "6"
  },
  {
    "marca": "FORD",
    "modelo": "E-250 ECONOLINE",
    "busquedas": "6"
  },
  {
    "marca": "SATURN",
    "modelo": "SC1",
    "busquedas": "6"
  },
  {
    "marca": "JMC",
    "modelo": "JX",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK CLASSIC",
    "busquedas": "6"
  },
  {
    "marca": "INFINITI",
    "modelo": "EX35",
    "busquedas": "6"
  },
  {
    "marca": "MASERATI",
    "modelo": "QUATTROPORTE",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK430",
    "busquedas": "6"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500 VAN",
    "busquedas": "6"
  },
  {
    "marca": "BMW",
    "modelo": "320I XDRIVE",
    "busquedas": "6"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLA250",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "NOVA",
    "busquedas": "6"
  },
  {
    "marca": "SUBARU",
    "modelo": "TRIBECA",
    "busquedas": "6"
  },
  {
    "marca": "PONTIAC",
    "modelo": "AZTEK",
    "busquedas": "6"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS460",
    "busquedas": "6"
  },
  {
    "marca": "JAC",
    "modelo": "T8 PRO",
    "busquedas": "6"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS350",
    "busquedas": "6"
  },
  {
    "marca": "JAGUAR",
    "modelo": "S-TYPE",
    "busquedas": "6"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR4",
    "busquedas": "6"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY SPORT",
    "busquedas": "6"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "FOX",
    "busquedas": "6"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "CROSSFIRE",
    "busquedas": "6"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CABRIO",
    "busquedas": "6"
  },
  {
    "marca": "BMW",
    "modelo": "328CI",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL550",
    "busquedas": "5"
  },
  {
    "marca": "SUZUKI",
    "modelo": "DZIRE",
    "busquedas": "5"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS X",
    "busquedas": "5"
  },
  {
    "marca": "SUBARU",
    "modelo": "GL",
    "busquedas": "5"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "DIAMANTE",
    "busquedas": "5"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C2500 SUBURBAN",
    "busquedas": "5"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "DAMAS/LABO",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL350",
    "busquedas": "5"
  },
  {
    "marca": "FORD",
    "modelo": "POLICE INTERCEPTOR UTILITY",
    "busquedas": "5"
  },
  {
    "marca": "SATURN",
    "modelo": "LS1",
    "busquedas": "5"
  },
  {
    "marca": "TOYOTA",
    "modelo": "GR86",
    "busquedas": "5"
  },
  {
    "marca": "JAC",
    "modelo": "X200",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 50",
    "busquedas": "5"
  },
  {
    "marca": "AUDI",
    "modelo": "TT QUATTRO",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500 VAN",
    "busquedas": "5"
  },
  {
    "marca": "JEEP",
    "modelo": "WAGONEER",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "ATTITUDE",
    "busquedas": "5"
  },
  {
    "marca": "JAGUAR",
    "modelo": "XF",
    "busquedas": "5"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA CRUZ",
    "busquedas": "5"
  },
  {
    "marca": "RAM",
    "modelo": "DAKOTA",
    "busquedas": "5"
  },
  {
    "marca": "AUDI",
    "modelo": "Q3",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK320",
    "busquedas": "5"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE CLUB WAGON",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS450",
    "busquedas": "5"
  },
  {
    "marca": "NISSAN",
    "modelo": "KICKS PLAY",
    "busquedas": "5"
  },
  {
    "marca": "RENAULT",
    "modelo": "KANGOO",
    "busquedas": "5"
  },
  {
    "marca": "SATURN",
    "modelo": "SKY",
    "busquedas": "5"
  },
  {
    "marca": "BMW",
    "modelo": "550I XDRIVE",
    "busquedas": "5"
  },
  {
    "marca": "BMW",
    "modelo": "325IS",
    "busquedas": "5"
  },
  {
    "marca": "ACURA",
    "modelo": "RL",
    "busquedas": "5"
  },
  {
    "marca": "BMW",
    "modelo": "X7",
    "busquedas": "5"
  },
  {
    "marca": "NISSAN",
    "modelo": "PULSAR NX",
    "busquedas": "5"
  },
  {
    "marca": "NISSAN",
    "modelo": "PULSAR",
    "busquedas": "5"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "EXPO",
    "busquedas": "5"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G3",
    "busquedas": "5"
  },
  {
    "marca": "SUZUKI",
    "modelo": "EECO CARGO",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "M2",
    "busquedas": "4"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 3500",
    "busquedas": "4"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT",
    "busquedas": "4"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER 3500",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S320",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DEFENDER",
    "busquedas": "4"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q50",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "T-CROSS",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK EV",
    "busquedas": "4"
  },
  {
    "marca": "JAC",
    "modelo": "T6",
    "busquedas": "4"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKZ",
    "busquedas": "4"
  },
  {
    "marca": "SATURN",
    "modelo": "LS",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BORA",
    "busquedas": "4"
  },
  {
    "marca": "FIAT",
    "modelo": "SIENA",
    "busquedas": "4"
  },
  {
    "marca": "JEEP",
    "modelo": "COMANCHE",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 HD",
    "busquedas": "4"
  },
  {
    "marca": "CADILLAC",
    "modelo": "XTS",
    "busquedas": "4"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "ASPEN",
    "busquedas": "4"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER CLUBMAN",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500 VAN",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "335D",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "325",
    "busquedas": "4"
  },
  {
    "marca": "SUBARU",
    "modelo": "WRX",
    "busquedas": "4"
  },
  {
    "marca": "JEEP",
    "modelo": "WRANGLER JK",
    "busquedas": "4"
  },
  {
    "marca": "BUICK",
    "modelo": "LUCERNE",
    "busquedas": "4"
  },
  {
    "marca": "KIA",
    "modelo": "NIRO",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "UPLANDER",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU LIMITED",
    "busquedas": "4"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE5",
    "busquedas": "4"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY XL",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "B1500",
    "busquedas": "4"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "XPANDER CROSS",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "SPRINTER 2500",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORSA",
    "busquedas": "3"
  },
  {
    "marca": "RENAULT",
    "modelo": "CLIO II",
    "busquedas": "3"
  },
  {
    "marca": "LINCOLN",
    "modelo": "LS",
    "busquedas": "3"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5",
    "busquedas": "3"
  },
  {
    "marca": "ACURA",
    "modelo": "CL",
    "busquedas": "3"
  },
  {
    "marca": "PORSCHE",
    "modelo": "911",
    "busquedas": "3"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX450H",
    "busquedas": "3"
  },
  {
    "marca": "SUBARU",
    "modelo": "B9 TRIBECA",
    "busquedas": "3"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX350L",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C2500",
    "busquedas": "3"
  },
  {
    "marca": "SUBARU",
    "modelo": "LOYALE",
    "busquedas": "3"
  },
  {
    "marca": "DAEWOO",
    "modelo": "MATIZ",
    "busquedas": "3"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VERONA",
    "busquedas": "3"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500 HD",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "335IS",
    "busquedas": "3"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON XL 1500",
    "busquedas": "3"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON XL 2500",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "CROWN VICTORIA",
    "busquedas": "3"
  },
  {
    "marca": "JEEP",
    "modelo": "GRAND CHEROKEE L",
    "busquedas": "3"
  },
  {
    "marca": "JEEP",
    "modelo": "CJ7",
    "busquedas": "3"
  },
  {
    "marca": "CHERY",
    "modelo": "TIGGO 4 PRO",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "550I",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MONTE CARLO",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "M3",
    "busquedas": "3"
  },
  {
    "marca": "CHANGAN",
    "modelo": "CM10",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK320",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK350",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML430",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 3500 HD",
    "busquedas": "3"
  },
  {
    "marca": "VOLVO",
    "modelo": "V40",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLC300",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E550",
    "busquedas": "3"
  },
  {
    "marca": "MAZDA",
    "modelo": "929",
    "busquedas": "3"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER VELAR",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "190D",
    "busquedas": "2"
  },
  {
    "marca": "AUDI",
    "modelo": "A3 QUATTRO",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "530XI",
    "busquedas": "2"
  },
  {
    "marca": "JAGUAR",
    "modelo": "F-TYPE",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SYCLONE",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SL550",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "LUV",
    "busquedas": "2"
  },
  {
    "marca": "TOYOTA",
    "modelo": "C-HR",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "750I",
    "busquedas": "2"
  },
  {
    "marca": "LINCOLN",
    "modelo": "CONTINENTAL",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "M5",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK55 AMG",
    "busquedas": "2"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX550",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAVERSE LIMITED",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT CC",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "300SDL",
    "busquedas": "2"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE XL",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "G20",
    "busquedas": "2"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER 1500",
    "busquedas": "2"
  },
  {
    "marca": "SUZUKI",
    "modelo": "LIANA",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "306",
    "busquedas": "2"
  },
  {
    "marca": "MERCURY",
    "modelo": "TOPAZ",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "TOWNER",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C200",
    "busquedas": "2"
  },
  {
    "marca": "MAZDA",
    "modelo": "E2200",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "206",
    "busquedas": "2"
  },
  {
    "marca": "SUZUKI",
    "modelo": "CIAZ",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "TEMPO",
    "busquedas": "2"
  },
  {
    "marca": "SAAB",
    "modelo": "9-3",
    "busquedas": "2"
  },
  {
    "marca": "TESLA",
    "modelo": "S",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "TSURU",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500 HD CLASSIC",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "228I",
    "busquedas": "2"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q70L",
    "busquedas": "2"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q60",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "330I XDRIVE",
    "busquedas": "2"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC40",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "R20 SUBURBAN",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CL500",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "AURA",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOL",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S550",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "228I GRAN COUPE",
    "busquedas": "2"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AGYA",
    "busquedas": "2"
  },
  {
    "marca": "EAGLE",
    "modelo": "TALON",
    "busquedas": "2"
  },
  {
    "marca": "DATSUN",
    "modelo": "PICKUP",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "C-MAX",
    "busquedas": "2"
  },
  {
    "marca": "INFINITI",
    "modelo": "M35",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E55 AMG",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "535D XDRIVE",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500 CLASSIC",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S430",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "340I XDRIVE",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOLF R",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TRANSPORTER",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "210",
    "busquedas": "2"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "CORDIA",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "300ZX",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "CIVILIAN",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "FIREBIRD",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "K3",
    "busquedas": "2"
  },
  {
    "marca": "SUBARU",
    "modelo": "JUSTY",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV3500",
    "busquedas": "2"
  },
  {
    "marca": "CHERY",
    "modelo": "TIGGO 2 PRO",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "MONTANA",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "K1500",
    "busquedas": "1"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER 2500",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS350D",
    "busquedas": "1"
  },
  {
    "marca": "MAXUS",
    "modelo": "D90",
    "busquedas": "1"
  },
  {
    "marca": "ISUZU",
    "modelo": "ASCENDER",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "S5",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLE350",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "I8",
    "busquedas": "1"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER CITY",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V40 CROSS COUNTRY",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V50",
    "busquedas": "1"
  },
  {
    "marca": "CADILLAC",
    "modelo": "CATERA",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "B250",
    "busquedas": "1"
  },
  {
    "marca": "ASTON MARTIN",
    "modelo": "DBS",
    "busquedas": "1"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q40",
    "busquedas": "1"
  },
  {
    "marca": "SATURN",
    "modelo": "SW2",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "228I XDRIVE",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "740IL",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONORA",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "D250",
    "busquedas": "1"
  },
  {
    "marca": "JMC",
    "modelo": "MINIBUS",
    "busquedas": "1"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "PRECIS",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "500SEL",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS C",
    "busquedas": "1"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PACIFICA",
    "busquedas": "1"
  },
  {
    "marca": "KIA",
    "modelo": "GRAND CARNIVAL",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "F-150 HERITAGE",
    "busquedas": "1"
  },
  {
    "marca": "NISSAN",
    "modelo": "NX",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "LANOS",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "A7",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "750LI",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "90 QUATTRO",
    "busquedas": "1"
  },
  {
    "marca": "CADILLAC",
    "modelo": "DTS",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "LUMINA",
    "busquedas": "1"
  },
  {
    "marca": "ACURA",
    "modelo": "ZDX",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "430I",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS PASAJEROS",
    "busquedas": "1"
  },
  {
    "marca": "HONDA",
    "modelo": "ACCORD CROSSTOUR",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MATIZ",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-70",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA IKON",
    "busquedas": "1"
  },
  {
    "marca": "HONDA",
    "modelo": "CLARITY",
    "busquedas": "1"
  },
  {
    "marca": "MERCURY",
    "modelo": "MILAN",
    "busquedas": "1"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "GRAND VOYAGER",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORSICA",
    "busquedas": "1"
  },
  {
    "marca": "LAMBORGHINI",
    "modelo": "MURCIELAGO",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "GRANADA",
    "busquedas": "1"
  },
  {
    "marca": "RENAULT",
    "modelo": "SCENIC",
    "busquedas": "1"
  },
  {
    "marca": "MERCURY",
    "modelo": "CAPRI",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SPRINTER 2500",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SPRINTER",
    "busquedas": "1"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "3008",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CRAFTER",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "ASPIRE",
    "busquedas": "1"
  },
  {
    "marca": "TESLA",
    "modelo": "Y",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "EOS",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "645CI",
    "busquedas": "1"
  },
  {
    "marca": "TESLA",
    "modelo": "3",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500",
    "busquedas": "1"
  },
  {
    "marca": "JAGUAR",
    "modelo": "XE",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOLF SPORTWAGEN",
    "busquedas": "1"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES350",
    "busquedas": "1"
  },
  {
    "marca": "JAGUAR",
    "modelo": "F-PACE",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C10 SUBURBAN",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "NIVUS",
    "busquedas": "1"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SJ410",
    "busquedas": "1"
  },
  {
    "marca": "HUMMER",
    "modelo": "H1",
    "busquedas": "1"
  },
  {
    "marca": "SUZUKI",
    "modelo": "S-CROSS",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "G63 AMG",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "535I XDRIVE",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "R32",
    "busquedas": "1"
  },
  {
    "marca": "SUZUKI",
    "modelo": "KIZASHI",
    "busquedas": "1"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "AVANTE",
    "busquedas": "1"
  },
  {
    "marca": "CHANGAN",
    "modelo": "CS35 PLUS",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "535I GT",
    "busquedas": "1"
  },
  {
    "marca": "JAC",
    "modelo": "JS2",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "SPRINTER 3500",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "THUNDERBIRD",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S500",
    "busquedas": "1"
  },
  {
    "marca": "FIAT",
    "modelo": "500X",
    "busquedas": "1"
  },
  {
    "marca": "FIAT",
    "modelo": "124 SPIDER",
    "busquedas": "1"
  },
  {
    "marca": "SUBARU",
    "modelo": "DL",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "VIRTUS",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "RAMCHARGER",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML63 AMG",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "V1500 SUBURBAN",
    "busquedas": "1"
  },
  {
    "marca": "SATURN",
    "modelo": "L300",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "230I XDRIVE",
    "busquedas": "1"
  },
  {
    "marca": "SMART",
    "modelo": "FORTWO",
    "busquedas": "1"
  },
  {
    "marca": "LEXUS",
    "modelo": "SC430",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK550",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "NAVAJO",
    "busquedas": "1"
  },
  {
    "marca": "SATURN",
    "modelo": "L200",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAILBLAZER EXT",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "A5",
    "busquedas": "1"
  }
];

export default preloadedVehiclesModels;
